import { format, formatDistanceToNow, isValid } from "date-fns";
import { Stack } from "@mui/material";
import OverviewRefreshButton from "src/scenes/overview/overview-components/overview-refresh-button";
import React from "react";
import Tooltip from "@mui/material/Tooltip";

const OverviewRefreshSection = ({ cachedAt, setRefresh }) => {
    if (!cachedAt) return null;
    return (
        isValid(new Date(cachedAt)) && (
            <Stack direction="row" justifyContent="flex-end" style={{ width: "100%" }}>
                <Tooltip title={format(new Date(cachedAt), "EEEE, dd MMMM yyyy HH:mm")}>
                    <p style={{ fontSize: "12px", fontWeight: 300, margin: "6px" }}>
                        Last refresh {formatDistanceToNow(new Date(cachedAt), { addSuffix: true })}
                    </p>
                </Tooltip>
                <OverviewRefreshButton setRefresh={setRefresh} />
            </Stack>
        )
    );
};

export default OverviewRefreshSection;
